<template>
  <div>
    <slotBase :bg-grey="true" :loading="isLoading">
      <template v-slot:content>
        <div
          class="w-100 position-absolute"
          style="
            height: 150px;
            border-radius: 0px 0px 16px 16px;
            background: linear-gradient(90deg, #e1ebfe 0%, #fff 100%);
          "
        ></div>
        <div class="position-relative p-a-20">
          <p class="f-Overpass f-w-700 f-24 m-0">
            Hai,
            {{ dataDashboard.nama_awal + " " + dataDashboard.nama_akhir }}
            !
          </p>
        </div>

        <div
          class="slider d-flex p-x-20"
          style="position: relative; left: 24px"
        >
          <template v-for="(dataEpay, index) in dataUserEpay.customer">
            <template v-if="dataEpay.outlet !== null && dataEpay.quota_emoney?.jenis_emoney == 2">
              <balanceCard
                :namaOutlet="dataEpay.outlet.nama"
                :tanggalDibuat="dataEpay.outlet.created_at"
                :namaAkun="dataEpay?.nama"
                :saldoAkun="dataEpay.quota_emoney.saldo"
                :kota-outlet="dataUserEpay.customer[index].outlet.kota"
                :latitude-outlet="dataUserEpay.customer[index].outlet.latitude"
                :longtitude-outlet="
                  dataUserEpay.customer[index].outlet.longitude
                "
                :index="index"
                :key="index"
            /></template>
            <template
              v-if="
                dataEpay.outlet !== null &&
                dataEpay.quota_emoney !== null &&
                dataEpay.quota_emoney.saldo !== 0 &&
                dataEpay.quota_emoney.masa_aktif >= new Date().getTime() &&
                dataEpay.quota_emoney?.jenis_emoney !== 2
              "
            >
              <balanceCard
                :namaOutlet="dataEpay.outlet.nama"
                :tanggalDibuat="dataEpay.outlet.created_at"
                :namaAkun="dataEpay.nama"
                :saldoAkun="dataEpay.quota_emoney.saldo"
                :kota-outlet="dataUserEpay.customer[index].outlet.kota"
                :latitude-outlet="dataUserEpay.customer[index].outlet.latitude"
                :longtitude-outlet="
                  dataUserEpay.customer[index].outlet.longitude
                "
                :index="index"
                :key="index"
              />
            </template>
          </template>
          <template v-if="dataUserEpay.customer === null || dataCard < 1">
            <emptyCard />
          </template>
        </div>

        <template v-if="mesinBerjalan == 0">
          <welcomeCard />
        </template>

        <template v-if="mesinBerjalan > 0">
          <div class="main-content p-x-20 mt-3">
            <div
              class="next d-flex flex-column align-items-start align-self-stretch mt-4"
              style="gap: 16px"
            >
              <p class="f-Overpass f-w-700 f-18 m-0">Sedang Berlangsung</p>
              <template v-for="(listLayanan, index) in listSnapTransaksi">
                <runningCard
                  v-if="listLayanan.snap_transaksi_detail[0].status != 4"
                  :layanan="
                    listLayanan.snap_transaksi_detail[0].snap_layanan.nama
                  "
                  :nama-mesin="listLayanan.snap_transaksi_detail[0].snap_mesin.nama"
                  :idmesin="listLayanan.snap_transaksi_detail[0].idmesin"
                  :nama-outlet="listLayanan.outlet.nama"
                  :durasi="listLayanan.snap_transaksi_detail[0].durasi"
                  :time-finish="listLayanan.finished_at"
                  :key="index"
                  @finish="updateListSnap(index)"
                />
              </template>
            </div>
          </div>
        </template>
      </template>
      <template v-slot:footer-bottom
        ><bottomBar :beranda-page="true"
      /></template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import emptyCard from "../components/emptyCard.vue";
import balanceCard from "../components/balanceCard.vue";
import runningCard from "../components/runningCard.vue";
import welcomeCard from "../components/welcomeCard.vue";
import bottomBar from "@/components/design/bottomBar.vue";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "dashboardUtama",
  components: {
    slotBase,
    emptyCard,
    balanceCard,
    runningCard,
    welcomeCard,
    bottomBar,
  },
  data() {
    return {
      condition: 3,
      isLoading: false,
      dataCard: 0,
    };
  },

  computed: {
    ...mapState("dashboard", {
      dataDashboard: "dataDashboard",
      dataUserEpay: "dataUserEpay",
      listSnapTransaksi: "listSnapTransaksi",
      mesinBerjalan: "mesinBerjalan",
    }),
  },

  methods: {
    ...mapActions({
      getDataDashboard: "dashboard/getDataDashboard",
      getCustomerByID: "dashboard/getCustomerByID",
    }),
    ...mapMutations({
      setListSnapTransaksi: 'setListSnapTransaksi'
    }),

    async updateListSnap(listIndex) {
      const newVal = this.listSnapTransaksi;
      newVal.splice(listIndex, 1)
			await this.getDataDashboard();
      // this.setListSnapTransaksi(newVal);
    },

    // getTangal() {
    //   console.log(new Date("2023-12-29").getTime());
    // },

    checkButton() {
      alert(this.mesinBerjalan);
    },

    // checkCardEpay(outlet, saldo, masaAktif) {
    //   console.log(new Date("2023-12-20").getTime());
    //   console.log("Saldo: ", saldo);
    //   if (outlet !== null && saldo !== 0 && masaAktif >= new Date().getTime()) {
    //     this.dataCard += 1;
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
  },

  async mounted() {
    this.$socket.on('connect', () => {
        console.log('connected');
      })
    this.isLoading = true;
    if (localStorage.getItem("token") === null) {
      this.$router.push({ name: "login" });
    } else {
      await this.getDataDashboard();
      await this.getCustomerByID().then((res) => {
        if (res.status == 200) {
          this.isLoading = false;
          // if (this.dataUserEpay.customer !== null) {
          for (let i = 0; i < this.dataUserEpay.customer.length; i++) {
            if (this.dataUserEpay.customer[i].quota_emoney !== null) {
              if (
                this.dataUserEpay.customer[i].quota_emoney.jenis_emoney == 2
              ) {
                this.dataCard += 1;
              } else {
                if (
                  this.dataUserEpay.customer[i].outlet !== null &&
                  this.dataUserEpay.customer[i].quota_emoney !== null &&
                  this.dataUserEpay.customer[i].quota_emoney.saldo !== 0 &&
                  this.dataUserEpay.customer[i].quota_emoney.masa_aktif >=
                    new Date().getTime()
                ) {
                  this.dataCard += 1;
                }
              }
            }
          }
        }
      });
    }
    // console.log(this.dataCard);
  },
};
</script>

<style scoped>
.slider {
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
.slider::-webkit-scrollbar {
  width: 0.1em;
}

.slider::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
